<template>
    <SidebarChild :selected-item="value" :items="ContentMenuItems" :focusActive="true" @selected="selectedItem" />
</template>
<script>
import SidebarChild from "../../../../components/Sidebar/SidebarChild.vue";
import ContentMenuItems from "./ContentMenuItems";
import { mapGetters } from "vuex";
export default {
    name: "ContentMenu",
    components: {
        SidebarChild,
    },
    props: {
        value: {
            type: String,
            default: null,
        },
    },
    computed: {
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
    },
    data: () => {
        return {
            ContentMenuItems: ContentMenuItems(this),
        };
    },
    mounted() {
        this.ContentMenuItems = ContentMenuItems(this);
    },
    methods: {
        selectedItem({ key }) {
            this.$emit("input", key);
        },
    },
    watch: {
        $route() {
            if (this.$route.path === "/contents") {
                this.selectedItem({ key: "templates" });
            }
            if (this.$route.path === "contents/templates") {
                this.selectedItem({ key: "templates" });
            }
            if (this.$route.path === "/contents/system-messages") {
                this.selectedItem({ key: "system-messages" });
            }
            if (this.$route.path === "/contents/catalog") {
                this.selectedItem({ key: "catalog" });
            }
            if (this.$route.path === "/contents/forbidden-inputs") {
                this.selectedItem({ key: "forbidden-inputs" });
            }
            if (this.$route.path === "/contents/tags") {
                this.selectedItem({ key: "tags" });
            }
        },
    },
};
</script>
